/* ============================================================================
   form-validation-messages.js
   Replaces the browser's built-in constraint-validation bubbles with the
   storefront's own translated strings, so they follow the site language
   instead of the browser's UI language.
   ========================================================================== */
(function () {
  'use strict';

  var node = document.querySelector('[data-validation-messages]');
  if (!node) return;

  var M;
  try {
    M = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }

  function fill(template, values) {
    return String(template).replace(/\[(min|max)\]/g, function (_, key) {
      return values[key] != null ? values[key] : '';
    });
  }

  function messageFor(field) {
    var v = field.validity;
    if (!v || v.valid) return '';

    if (v.valueMissing) {
      if (field.type === 'checkbox' || field.type === 'radio') return M.checkbox;
      if (field.tagName === 'SELECT') return M.select;
      return M.required;
    }
    if (v.typeMismatch) {
      if (field.type === 'email') return M.email;
      return M.required;
    }
    if (v.patternMismatch) {
      return field.type === 'email' ? M.email : M.required;
    }
    if (v.tooShort) return fill(M.tooShort, { min: field.minLength });
    if (v.tooLong) return fill(M.tooLong, { max: field.maxLength });
    if (v.badInput) return M.number;
    if (v.rangeUnderflow || v.rangeOverflow || v.stepMismatch) {
      return fill(M.range, { min: field.min, max: field.max });
    }
    return M.required;
  }

  function apply(field) {
    if (!field || typeof field.setCustomValidity !== 'function') return;
    /* Clear first, otherwise the stale custom message keeps the field invalid. */
    field.setCustomValidity('');
    if (field.validity && !field.validity.valid) {
      field.setCustomValidity(messageFor(field));
    }
  }

  /* `invalid` does not bubble, so listen in the capture phase on the document. */
  document.addEventListener(
    'invalid',
    function (event) {
      apply(event.target);
    },
    true
  );

  /* Drop the custom message as soon as the visitor fixes the field, otherwise
     the browser keeps treating it as invalid. */
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (field && typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field && typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  });
})();
